import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { ButtonProps } from "@/components/ui/button";

export function ButtonOutline({ className, ...props }: ButtonProps) {
  return (
    <Button
      variant="outline"
      size="pill-lg"
      className={cn("", className)}
      {...props}
    />
  );
}
